import { Select, SelectProps } from 'formik-antd';

import WithLoading from './WithLoading';

const FormikSelectWithLoadingHOC = WithLoading<SelectProps>(Select);

type FormikSelectWithLoadingType = typeof FormikSelectWithLoadingHOC;

interface IFormikSelectWithLoading extends FormikSelectWithLoadingType {
  Option: typeof Select.Option;
  OptGroup: typeof Select.OptGroup;
}

const FormikSelectWithLoading = FormikSelectWithLoadingHOC as IFormikSelectWithLoading;

FormikSelectWithLoading.Option = Select.Option;
FormikSelectWithLoading.OptGroup = Select.OptGroup;

export default FormikSelectWithLoading;
